export enum UIVariant {
    Outline = 'outline',
    Filled = 'filled',
    DarkTranslucent = 'dark-translucent',
}
